import React from 'react';
import classNames from 'classnames';
import Icon from './icon';

interface RadioButtonsProps {
  options: any[];
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  getLabel: (value: any) => any;
  getValue: (value: any) => string | number;
  vertical?: boolean;
  fullWidth?: boolean;
  disabledOptions?: any[];
  alignTop?: boolean;
  element?: 'div' | 'button';
  showCheckmark?: boolean;
}

const RadioButtons = ({
  options,
  value,
  onChange,
  disabled,
  getLabel,
  getValue,
  vertical,
  fullWidth,
  disabledOptions = [],
  alignTop,
  element = 'button',
  showCheckmark = false,
}: RadioButtonsProps) => {
  const _onChange = (val) => {
    if (disabled || val === value) return;
    onChange(val);
  };

  const isActive = (item) => {
    return (
      value === getValue(item) ||
      ([null, undefined].indexOf(value) >= 0 && [null, undefined].indexOf(getValue(item)) >= 0)
    );
  };

  const isDisabled = (item) => {
    return disabled || disabledOptions.indexOf(getValue(item)) >= 0 || item.disabled;
  };

  return (
    <div
      className={classNames({
        'btn-group': true,
        'btn-group--vertical': vertical,
        'btn-group--align-top': alignTop,
      })}
      data-toggle="buttons"
    >
      {options &&
        options.map((item) =>
          React.createElement(
            element,
            {
              key: getValue(item) || String(getValue(item)),
              className: classNames('btn btn-radio', {
                active: isActive(item),
                'btn-radio--disabled': isDisabled(item),
                'is-stack': vertical,
                'btn-radio--checkmark': showCheckmark,
              }),
              type: element === 'button' ? 'button' : undefined,
              onClick: () => _onChange(getValue(item)),
              disabled: element === 'button' ? isDisabled(item) : undefined,
              style: { width: fullWidth ? '100%' : 'auto' },
            },
            showCheckmark && isActive(item) ? (
              <span className="btn-radio__checkmark-icon">
                <Icon name="check-mark" width={24} height={24} />
              </span>
            ) : (
              getLabel(item)
            ),
          ),
        )}
    </div>
  );
};

export default RadioButtons;
